import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McoValChart = ({ selectedPeriod, selectedPbms, selectedCtrts, selectedDueDates }) => {

  const { navigateTo } = useNavState();

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {

    if (!selectedPeriod?.id) {
      return;
    }

    const pbmIds = selectedPbms.map(pbm => pbm.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const dueDates = selectedDueDates.map(dueDate => dueDate.value);
    const reqParam = {
      periodId: selectedPeriod?.id,
      pbmIds,
      ctrtIds,
      dueDates
    };

    rsrc.data('sc', 'MCO_VAL_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [selectedPeriod, selectedPbms, selectedCtrts, selectedDueDates]);

const navigateToInvList = (dataPoint) => {

    const valCode = dataPoint.label;
    let expr = ExprUtils.contains('valRes', valCode);

    const selectedPeriodId = selectedPeriod?.id;
    if (selectedPeriodId) {
      expr = ExprUtils.and(expr, ExprUtils.whereParams('invPeriodId', selectedPeriodId));
    }

    const selectedPbmIds = selectedPbms.map(pbm => pbm.id);
    if (selectedPbmIds.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('pbmId', selectedPbmIds));
    }

    const selectedCtrtIds = selectedCtrts.map(ctrt => ctrt.id);
    if (selectedCtrts.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('ctrtId', selectedCtrtIds));
    }

    const selectedDueDateValues = selectedDueDates.map(dueDate => dueDate.value);
    if (selectedDueDates.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('dueDate', selectedDueDateValues));
    }
    
    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };

    navigateTo('sc/mco-inv', navState);
};


  if (!data || data.length === 0) return;

  return (
    <PieChart
      data={data}
      onClick={(dataPoint) => navigateToInvList(dataPoint)}
    />
  );
};
